import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  root: {
    padding: '0',
    minWidth: 'initial',
    minHeight: 'initial',
    '&.small': {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.fontSizeTinyish,
      textDecoration: 'underline',
      '&:hover': {
        background: 'none',
      },
    },
  },
  disabled: {
    opacity: 0.5,
  },
})

const TextOnlyButton = ({ classes, className, label, size, ...rest }) => {
  const buttonClasses = {
    root: classes.root,
    disabled: classes.disabled,
  }
  return (
    <Button
      classes={buttonClasses}
      className={cn(className, size)}
      color="primary"
      variant="text"
      disableRipple
      {...rest}
    >
      {label}
    </Button>
  )
}

TextOnlyButton.defaultProps = {
  size: 'small',
}

const TextOnlyButtonComponent = withStyles(styles)(TextOnlyButton)
TextOnlyButtonComponent.displayName = 'TextOnlyButton'
export default TextOnlyButtonComponent
